import React, { useState, useEffect } from "react";
import styles from "./index.module.css";
import locationText from "assets/files/location.txt";


export default function Location() {
    const [text, setText] = useState("");

    useEffect(() => {
        fetch(locationText)
            .then((res) => res.text())
            .then((data) => setText(data));
    }, []);

    return (
        <div className={styles.wrapper}>
            <pre className={styles.textBox}>{text}</pre>
        </div>
    );
}